import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, VERSION, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/security/auth.service';

import { Area } from 'src/app/shared/model/tickets/area.model';
import { Comentario } from 'src/app/shared/model/tickets/comentario.model';
import { Prioridad } from 'src/app/shared/model/tickets/prioridad.model';
import { Tickets } from 'src/app/shared/model/tickets/tickets.model';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { TicketsEstatus } from 'src/app/utilerias/enums/tickets-estatus.enum';
import swal from 'sweetalert2';

import { TipoSolicitud } from 'src/app/shared/model/tickets/tipoSolicitud.model';
import { EmpresaLista } from 'src/app/shared/model/tickets/empresaLista.model';
import { TicketsService } from '../../tickets.service';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatError, MatLabel } from '@angular/material/input';
import { NgIf, NgFor } from '@angular/common';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelectionList, MatListOption } from '@angular/material/list';

@Component({
    selector: 'app-solicitud-tickets',
    standalone: true,
    templateUrl: './solicitudTickets.component.html',
    styleUrls: ['./solicitudTickets.component.css'],
    imports: [MatIconButton, MatIcon, FormsModule, ReactiveFormsModule, MatFormField, MatInput, NgIf, MatError, MatSelect, NgFor, MatOption, MatLabel, MatSelectionList, MatListOption]
})
export class SolicitudTicketsComponent implements OnInit {
  
  version = VERSION.full;
  dateNow: Date = new Date();
  fechaActual: string;
  fechaElegida: string;
  idUsuario: number;
  nombreCompleto: string;
  @ViewChild('asuntoCtrl') inputAsuntoCtrl: ElementRef;
  areas: Area[]=[];
  prioridades: Prioridad[];
  empresas: EmpresaLista[];
  tickets: Tickets;
  options: FormGroup;
  date = new FormControl(new Date());
  serializedDate = new FormControl((new Date()).toISOString());
  areaSeleccionada: Area = new Area();
  areaSeleccionadaRes: Area = new Area();
  empresaSeleccionada: EmpresaLista;
  empresaSelect: boolean =false;
  agregaComentario: boolean;
  evidencia = [];
  selectedOptions = [];
  index: number;
  btnElimina: boolean = true;
  btnAgrega: boolean = false;
  totalsize = 0;
  comentario: Comentario;
  itemDefault: Area;
  tipoSolicitud: TipoSolicitud[];
  prioridadesFiltradas: Prioridad[];
  areasResolutoras: Area[];
  solicitud : string;
  idSolicitud: string;

  constructor(private router: Router, private fb: FormBuilder, public modal: MatDialogRef<SolicitudTicketsComponent>,
    private ticketsService: TicketsService, private authS: AuthService, private renderer: Renderer2,
    // Sin zone.js, lo que llega del servidor solo se pinta si se avisa (markForCheck).
    private cambios: ChangeDetectorRef) { }

  ngOnInit() {
    this.comentario = new Comentario();
    this.tickets = new Tickets();
    this.options = this.fb.group({
      asuntoCtrl: ['', Validators.required],
      nombreCtrl: ['', Validators.required],
      empresaCtrl: ['', Validators.required],
      areaCtrl: [''],
      areaResCtrl: [''],
      fechaSolicitudCtrl: ['', Validators.required],
      prioridadCtrl: ['', Validators.required],
      justificacionCtrl: ['', Validators.required],
      descripcionCtrl: ['', Validators.required],
      telefonoCtrl: [''],
      TipoSolicitudCtrl: [''],

    });
  
    // this.options.valueChanges.subscribe(selectedValue => {
    //   console.log(selectedValue)     // Sirve para visualizar los cambios del formulario de manera dinamica
    // })

    this.ticketsService.consultarArea(UrlConstantes.consultarArea).subscribe(res => {
      if (res != null) {
        this.areas = res.list;
        this.idSolicitud = res.param1;
        this.areasResolutoras = this.areas.filter(area => area.id == Number.parseInt(this.idSolicitud));
        this.areaSeleccionadaRes.id = this.areasResolutoras[0]?.id;
        this.areaSeleccionadaRes.area = this.areasResolutoras[0]?.area;
        this.cambios.markForCheck();
        this.ticketsService.consultarTipoSolicitud().subscribe(resp => {
          if (resp != null) {
            this.tipoSolicitud = resp.list;
            this.tipoSolicitud = this.tipoSolicitud.filter(incidente => incidente.id == this.areasResolutoras[0]?.idTicketSolicitud);
            this.solicitud = this.tipoSolicitud[0]?.nombre;
            this.cambios.markForCheck();
          }
        });
      }
    });

    this.ticketsService.consultarPrioridad().subscribe(resp => {
      if (resp != null) {
        this.prioridades = resp.list;
        this.prioridadesFiltradas=resp.list;
        this.cambios.markForCheck();
      }
    });

    this.ticketsService.consultarEmpresa(UrlConstantes.consultarEmpresaLista).subscribe(res => {
      if (res != null) {
        this.empresas = res.list;
        this.cambios.markForCheck();

        if(this.empresas.length ==1){
          this.empresaSeleccionada=this.empresas[0];
          this.empresaSelect=true;
          this.options.controls.empresaCtrl.setValue( this.empresaSeleccionada);
        }
     
      }
    });

    this.buscarUsuario();

    this.fechaActual = this.dateNow.toString();
    this.fechaActual = this.formatFecha(      this.fechaActual    );
    this.options.controls.fechaSolicitudCtrl.setValue( this.fechaActual);

  }

  subirEv() {
    const input = (<HTMLInputElement>document.getElementById('nameFile'));
    if (input.files.length > 0) {
      for (let i = 0; i <= input.files.length - 1; i++) {
        this.totalsize = this.totalsize + input.files.item(i).size;
        this.evidencia.push(input.files[i]);
      }
    }
    (<HTMLInputElement>document.getElementById('nameFile')).value = "";
  }

  elimina() {
    for (let i = 0; i < this.selectedOptions.length; ++i) {
      this.index = this.evidencia.findIndex(item => item.name == this.selectedOptions[i].name);
      this.evidencia.splice(this.index, 1);
    }
    (<HTMLInputElement>document.getElementById('nameFile')).value = "";
  }

  limpiar(): void {
    this.options.reset();
    this.buscarUsuario();
    if(this.empresas.length ==1){
      this.empresaSeleccionada=this.empresas[0];
      this.empresaSelect=true;
      this.options.controls.empresaCtrl.setValue( this.empresaSeleccionada);
    }
    //this.inputAsuntoCtrl.nativeElement.focus();
  }

  onNgModelChange($event) {
    if ($event.length != 0) {
      this.btnElimina = false;
    } else {
      this.btnElimina = true;
    }
  }

  salir() {
    this.modal.close();
  }

  guardar(): void {
    this.tickets.areaSolicitante = this.areaSeleccionada.area;
    this.tickets.areaResolutora = this.areaSeleccionadaRes.area;
    this.tickets.id_area = this.areaSeleccionada.id;
    this.tickets.id_areaResolutora = this.areaSeleccionadaRes.id;
    this.tickets.id_empresaDirigido = this.empresaSeleccionada.id;   
    this.tickets.tipoSolicitud = this.solicitud;

    // if(this.empresaSeleccionada==null){
    //   swal.fire({
    //     title: '¡Es necesario seleccionar una empresa! ',
    //     timer: 5000,
    //     type: 'warning',
    //     showConfirmButton: true
    //   }).then(responeMsg => {
    //   });
    //   return;
    // }
    this.ticketsService.guardarTicket(this.tickets).subscribe(res => {
      if (res != null) {
        swal.fire({
          title: '¡Se ha generado la solicitud de Ticket! Con el folio: '+res.id_ticket,
          timer: 5000,
          icon: 'success',
          showConfirmButton: true
        }).then(responeMsg => {
          if (res.pCodRetorno === '00000') {
            this.comentario.id_usuario = this.tickets.id_UsuarioSolicito;
            this.comentario.id_estatus = res.id_estatus;
            this.comentario.id_ticket = res.id_ticket;
            this.ticketsService.guardarComentario(this.comentario).subscribe(resComment => {
              for (let i = 0; i < this.evidencia.length; i++) {
                const formData = new FormData();
                formData.append('file', this.evidencia[i], "$" + resComment.id + "$" + this.evidencia[i].name);
                this.ticketsService.uploadEvidencia(formData).subscribe();
              }
            });
            this.modal.close(this.tickets);
          } else {
            //this.inputAsuntoCtrl.nativeElement.focus();
          }
        });
      } else {
        swal.fire({
          title: ' Fallo la generación del Ticket.',
          timer: 5000,
          icon: 'error',
          showConfirmButton: true
        });
      }
    });
  }

  buscarUsuario() {
    this.authS.getSesion().subscribe(res => {
      this.tickets.nombreSolicitante = res.persona.nombre.concat(" ").concat(res.persona.apellidoPaterno).concat(" ").concat(res.persona.apellidoMaterno);
      this.tickets.id_UsuarioSolicito = res.usuario.id;
      this.tickets.id_Empresa = res.usuario.idEmpresa;
      this.tickets.id_Corporativo = res.usuario.idCorporativo;
      this.tickets.id_estatus = TicketsEstatus.ABIERTA;
      this.nombreCompleto = res.persona.nombre.concat(" ").concat(res.persona.apellidoPaterno).concat(" ").concat(res.persona.apellidoMaterno);
      this.areaSeleccionada.id = res.datos.id_area;
      this.areaSeleccionada.area = res.datos.area_empleado;
      this.cambios.markForCheck();
     this.options.controls.nombreCtrl.setValue( this.nombreCompleto);
      //** vuelve a pintar la fecha */
      this.fechaActual = this.dateNow.toString();
      this.fechaActual = this.formatFecha(        this.fechaActual      );

      this.options.controls.fechaSolicitudCtrl.setValue( this.fechaActual);
    });
  }

  formatFecha(str: any): string {
    const date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join('/');
  }

  orgValueChange() {
    this.prioridadesFiltradas = [];
    for (let i = 0; i < this.prioridades.length; i++) {
      if(this.prioridades[i].nombre === 'Alta'){
       if(this.tickets.tipoSolicitud === 'Incidencia'){
        this.prioridadesFiltradas.push(this.prioridades[i]);
       }
      }else{
        this.prioridadesFiltradas.push(this.prioridades[i]);
      }
    }
       this.tickets.prioridad=null;
  }

  onCloseClick() {
    this.modal.close();
  }
}
